import * as WebFs from '@lucidlink/web-fs/config-manager';
export const createGlobalSettingManager = (configManager) => {
    return new GlobalSettingManagerImpl(configManager);
};
class GlobalSettingManagerImpl {
    configManager;
    constructor(configManager) {
        this.configManager = configManager;
    }
    async set(settings) {
        const builder = this.configManager.getSettingsBuilder();
        const webFsSettings = settings.map(({ fullName, value }) => {
            const { target, name } = WebFs.settingFullNameFromString(fullName);
            return builder.parse(target, name, value);
        });
        return await this.configManager.set(webFsSettings);
    }
    async unset(settingNames) {
        const webFsSettingNames = settingNames.map((settingName) => WebFs.settingFullNameFromString(settingName));
        return await this.configManager.unset(webFsSettingNames);
    }
    async get(settingNames) {
        const webFsSettingNames = settingNames.map((settingName) => WebFs.settingFullNameFromString(settingName));
        const settings = await this.configManager.get(webFsSettingNames);
        return settings.map((setting) => {
            return {
                fullName: `${setting.fullName().target}.${setting.fullName().name}`,
                value: setting.effective().toString(),
                default: setting.default().toString(),
                isDefault: setting.global() === undefined,
            };
        });
    }
}
